import * as React from "react";


const ArrowIconSVG = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="15" height="24">
    <path
      fill="#171718"
      d="M2.13 24 0 21.87 9.87 12 0 2.13 2.13 0l12 12z"
    ></path>
  </svg> 
);

export default ArrowIconSVG;
